(function ($, root, undefined) {
	$(function () {
        const formContainer = document.querySelector('.getNotified');

		if (formContainer) {
			const observer = new MutationObserver((mutationsList, observer) => {
			// const form = formContainer.querySelector('form-embed');
			const form = formContainer.querySelector('shopify-forms-embed');

			if (form) {
				observer.disconnect(); // Stop observing once the form is found
				const shadow = form.shadowRoot;

				const sheet = new CSSStyleSheet();
				sheet.insertRule(`
					#form-container-ref section{
                        max-width:100%;
                    }
				`);
				sheet.insertRule(`
					#form-container-ref section h2{
                        color: #ffffff !important;
                        text-align: left;
                        font-family: "Nunito", sans-serif !important;
                        font-weight: 700 !important;
                        font-size: 18px !important;

                    }
				`);
				sheet.insertRule(`
					#form-container-ref section p{
                        font-family: "Nunito", sans-serif;
                        color: #ffffff !important;
                        text-align: left;
                    }
				`);
				sheet.insertRule(`
					._inline_1q1d2_47 ._formContainer_1q1d2_30{
                        max-width:100%;
                    }
				`);

				// sheet.insertRule(`
                //     form {
                //       display: grid !important;
                //       grid-template-columns: 32% 32% 30% !important; /* Two equal columns */
                //       grid-template-rows: auto !important; /* Automatically adjust row height */
                //     }
                // `);
                if (window.innerWidth <= 510) {
                    sheet.insertRule(`
                      form {
                        gap: 10px !important; /* Space between grid items */
                        grid-template-columns: 100% !important; /* Two equal columns */
                        grid-template-areas:
                          "first-name first-name"
                          "email email"
                          "submit submit" !important;
                      }
                    `);
                }else{
                    sheet.insertRule(`
                      form {
                        display: grid !important;
                        grid-template-columns: 1fr 1fr !important;
                        gap: 10px !important;
                        justify-content: space-between !important;
                        grid-template-areas:
                          "first-name email"
                          "submit submit" !important;
                      }
                    `);
                }

				sheet.insertRule(`
                    form > div:nth-child(2) {
                        grid-area: first-name !important;
                    }
                `);
				sheet.insertRule(`
                    form > div:nth-child(3) {
                        grid-area: email !important;
                    }
                `);
				// sheet.insertRule(`
                //     form > div:nth-child(3) {
                //         grid-area: email !important;
                //     }
                // `);
				// sheet.insertRule(`
                //     form > div:nth-child(4) {
                //         grid-area: phone-area !important;
				// 		align-items:flex-end;
                //     }
                // `);
				// sheet.insertRule(`
                //     form > div:nth-child(5) {
                //         grid-area: reason !important;
                //     }
                // `);
				// sheet.insertRule(`
                //     form > div:nth-child(6) {
                //         grid-area: msg !important;
                //     }
                // `);
				sheet.insertRule(`
                    form > button[type="submit"] {
                        grid-area: submit !important;
                    }
                `);
				sheet.insertRule(`
					input {
                        border-radius: 10px !important;
                        font-family: "Nunito", sans-serif !important;
                        font-style: normal !important;
                        font-size: 16px !important;
                        padding:10px !important;
                        color: black !important;
                        background-color:#ffffff !important;
                        border-bottom: none !important;
                        box-shadow: none !important;
					}
				`);


                sheet.insertRule(`
                    input::placeholder, textarea::placeholder, .business-need-text {
                        font-family: "Nunito", sans-serif !important;
                        font-weight: 700 !important;
                        font-size: 16px;
                        font-style: normal !important;
                        color: #402C4F !important;
                        opacity: 1 !important;
                        text-transform: capitalize !important;
                        line-height:1 !important;
                    }
                `);

                //submit button styling
                sheet.insertRule(`
                    button[type='submit'] {
                        font-family: "Nunito", sans-serif !important;
                        font-style: normal !important;
                        text-transform: capitalize !important;
                        color: #402C4F !important;
                        background: #EDE6F4 !important;
                        transition: all .3s ease-in-out .01s !important;
                        font-size: 15px !important;
                        border-radius: 10px !important;
                        text-align: center !important;
                        font-weight:700 !important;
                        padding:10px  !important;
                        margin-top:0px!important;
                        border: none!important;
                    }
                `);


                // Apply the styles to the Shadow DOM
                // @ts-ignore
                shadow.adoptedStyleSheets.push(sheet);
				// Add a class to the form container for further customization
				formContainer.classList.add('loaded');

				// --- Send the currently-selected variant with the submission ---
				// Requires a matching field (label/name/placeholder containing "variant")
				// added to this form in the Shopify Forms app.
				syncSelectedVariant(shadow, formContainer);
			}
			});

			// Observe for changes only within the custom section
			observer.observe(formContainer, { childList: true, subtree: true });

            // Resize event listener to act like media query
            window.addEventListener('resize', () => {
                // Trigger MutationObserver actions based on screen size
                observer.takeRecords(); // Forces MutationObserver to re-evaluate
            });
		}

		// Builds a human-readable string of the current variant, e.g.
		// "SnuzPod4 - Rose White (SKU: SN123) [ID: 4567890123]"
		function getCurrentVariant(formContainer) {
			const productForm = document.querySelector('.product-form-main');
			let id = '', title = '', sku = '';

			if (productForm) {
				const idField = productForm.querySelector('select[name="id"], input[name="id"]');
				if (idField) {
					id = idField.value || '';
					const option = idField.tagName === 'SELECT'
						? idField.options[idField.selectedIndex]
						: productForm.querySelector('select[name="id"] option[value="' + id + '"]');
					if (option) {
						title = (option.textContent.split(' - ')[0] || '').trim();
						sku = option.dataset.sku || '';
					}
				}
			}
			if (!sku && window.selectedSKU) sku = window.selectedSKU;
			// Single-variant products expose no option in the DOM, so fall back
			// to the SKU rendered server-side onto the container.
			if (!sku) sku = formContainer.dataset.productSku || '';

			const productTitle = (formContainer.dataset.productTitle || document.title || '')
				.replace(/\s+/g, ' ').trim();
			const name = [productTitle, title].filter(Boolean).join(' - ');
			let out = name;
			if (sku) out += ' (SKU: ' + sku + ')';
			return out;
		}

		// Sets a value on a framework-controlled input so the component's own
		// internal state updates (plain `el.value = x` is ignored on submit).
		function setNativeValue(el, value) {
			const proto = el.tagName === 'TEXTAREA'
				? window.HTMLTextAreaElement.prototype
				: window.HTMLInputElement.prototype;
			const setter = Object.getOwnPropertyDescriptor(proto, 'value').set;
			setter.call(el, value);
			el.dispatchEvent(new Event('input', { bubbles: true }));
			el.dispatchEvent(new Event('change', { bubbles: true }));
		}

		// Locates the "variant" field inside the form's shadow DOM.
		function findVariantInput(shadow) {
			const controls = shadow.querySelectorAll('input, textarea');
			for (const el of controls) {
				const attrs = [el.name, el.id, el.placeholder, el.getAttribute('aria-label')]
					.filter(Boolean).join(' ').toLowerCase();
				if (attrs.includes('variant')) return el;
				if (el.id) {
					const lbl = shadow.querySelector('label[for="' + el.id + '"]');
					if (lbl && lbl.textContent.toLowerCase().includes('variant')) return el;
				}
				// Label often rendered as a sibling inside the field wrapper.
				const wrap = el.closest('div');
				if (wrap && wrap.textContent.toLowerCase().includes('variant')) return el;
			}
			return null;
		}

		// Writes a value into a controlled (React) input and keeps retrying
		// until it "sticks" — i.e. the component's re-render no longer resets
		// it to empty. That confirms the value reached the internal state that
		// Shopify Forms serializes on submit.
		function writeValue(input, value, tries) {
			tries = tries || 0;
			setNativeValue(input, value);
			setTimeout(() => {
				if (input.value !== value && tries < 20) writeValue(input, value, tries + 1);
			}, 100);
		}

		// Finds the target field inside the form's shadow DOM, hides it from
		// shoppers, and keeps it filled with the current variant.
		function syncSelectedVariant(shadow, formContainer, attempt) {
			attempt = attempt || 0;
			const variantInput = findVariantInput(shadow);

			if (!variantInput) {
				// Inputs may render a tick after the embed — retry briefly.
				if (attempt < 10) setTimeout(() => syncSelectedVariant(shadow, formContainer, attempt + 1), 150);
				return;
			}

			const update = () => writeValue(variantInput, getCurrentVariant(formContainer));
			update();

			// Re-sync whenever the shopper changes a variant selection...
			const productForm = document.querySelector('.product-form-main');
			if (productForm) productForm.addEventListener('change', update);
			// ...and once more immediately before the form is submitted.
			const shadowForm = shadow.querySelector('form');
			if (shadowForm) shadowForm.addEventListener('submit', update, true);

			// Hide the field (and its label) from shoppers.
			const wrapper = variantInput.closest('div') || variantInput;
			wrapper.style.setProperty('display', 'none', 'important');
		}
	});
// @ts-ignore
})(jQuery, this);
